import type { IBadgeClaimState } from '../components/organisms/badge-claim/badge-claim.typings';

export interface BadgePerksDisplay {
  heading: string;
  text: string;
  isUnlocked: boolean;
}

interface BadgePerksDisplayInput {
  badgeState: IBadgeClaimState;
  perks?: string | null;
  collectedPerks?: string | null;
}

// Not every badge comes with a perk, so the box keeps one neutral heading in every state
export const BADGE_INFO_HEADING = 'Badge Information';

export function isBadgeStateCollected(badgeState: IBadgeClaimState) {
  return badgeState === 'collected' || badgeState === 'already-collected';
}

// The perks editor emits markup even when empty ("<br>", "<div></div>", "&nbsp;")
export function hasPerksText(html?: string | null) {
  if (!html) return false;
  return (
    html
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .trim().length > 0
  );
}

// Members who collected the badge see its collected perks in place of the regular
// perks; when the creator wrote none they keep seeing the regular perks.
export function getBadgePerksDisplay({
  badgeState,
  perks,
  collectedPerks,
}: BadgePerksDisplayInput): BadgePerksDisplay | null {
  if (isBadgeStateCollected(badgeState) && collectedPerks && hasPerksText(collectedPerks)) {
    return { heading: BADGE_INFO_HEADING, text: collectedPerks, isUnlocked: true };
  }
  if (!perks) return null;
  return { heading: BADGE_INFO_HEADING, text: perks, isUnlocked: false };
}
